export default "__VITE_ASSET__Dblp7XHx__"